// ============================================================================================
// STAGE 1 OF THE PORT — COPIED, NOT REWRITTEN.
//
// This is the customer code lifted verbatim out of flight-processor/index.html (lines
// 3125-3889). Nothing inside it has been retyped, so it cannot have drifted. The only changes
// are at the two ends: the IIFE became an exported function, and the three lines that hid the
// internal tool are gone because there is no internal tool on this site.
//
// Stage 2 converts this into real components one piece at a time. Until then it runs as-is.
// ============================================================================================
import { getPrice, isRoutePriced } from '../lib/pricing.js';
import { searchViaBridge } from '../lib/bridge.js';

export function initCustomer() {
  const view = document.getElementById('ymCustomer');
  if (!view) return;
  view.style.display = 'block';
  // Which build is this? Shown so "still broken" and "old page" can never be confused again.
  try { document.getElementById('ymcVer').textContent = 'build ' + __BUILD__; } catch (e) {}

  const $c = (id) => document.getElementById(id);
  const say = (m) => { $c('ymcStatus').textContent = m; };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const ampm = (t) => { const m = String(t || '').match(/(\d{1,2})h(\d{2})/); if (!m) return t || ''; let h = +m[1]; const ap = h < 12 ? 'am' : 'pm'; h = h % 12 || 12; return h + ':' + m[2] + ' ' + ap; };

  // code, city, airport, country — the airport name and country are what make a picker feel like
  // a real one rather than a list of abbreviations.
  const PORTS = [
    ['YUL', 'Montreal', 'Pierre Elliott Trudeau', 'Canada'],
    ['YTO', 'Toronto', 'All airports', 'Canada'],
    ['YYZ', 'Toronto', 'Pearson', 'Canada'],
    ['YTZ', 'Toronto', 'Billy Bishop City', 'Canada'],
    ['YOW', 'Ottawa', 'Macdonald-Cartier', 'Canada'],
    ['YVR', 'Vancouver', 'Vancouver Intl', 'Canada'],
    ['YYC', 'Calgary', 'Calgary Intl', 'Canada'],
    ['LGA', 'New York', 'LaGuardia', 'United States'],
    ['JFK', 'New York', 'John F. Kennedy', 'United States'],
    ['EWR', 'Newark', 'Liberty Intl', 'United States'],
    ['NYC', 'New York', 'All airports', 'United States'],
    ['MIA', 'Miami', 'Miami Intl', 'United States'],
    ['FLL', 'Fort Lauderdale', 'Hollywood Intl', 'United States'],
    ['MCO', 'Orlando', 'Orlando Intl', 'United States'],
    ['BOS', 'Boston', 'Logan Intl', 'United States'],
    ['ORD', 'Chicago', "O'Hare Intl", 'United States'],
    ['IAD', 'Washington', 'Dulles Intl', 'United States'],
    ['ATL', 'Atlanta', 'Hartsfield-Jackson', 'United States'],
    ['LAX', 'Los Angeles', 'Los Angeles Intl', 'United States'],
    ['SFO', 'San Francisco', 'San Francisco Intl', 'United States'],
    ['DFW', 'Dallas', 'Fort Worth Intl', 'United States'],
    ['IAH', 'Houston', 'George Bush Intercontinental', 'United States'],
    ['BHM', 'Birmingham', 'Shuttlesworth Intl', 'United States'],
    ['PHL', 'Philadelphia', 'Philadelphia Intl', 'United States'],
    ['GRU', 'Sao Paulo', 'Guarulhos', 'Brazil'],
    ['GIG', 'Rio de Janeiro', 'Galeao', 'Brazil'],
    ['EZE', 'Buenos Aires', 'Ezeiza', 'Argentina'],
    ['SCL', 'Santiago', 'Arturo Merino Benitez', 'Chile'],
    ['LIM', 'Lima', 'Jorge Chavez', 'Peru'],
    ['BOG', 'Bogota', 'El Dorado', 'Colombia'],
    ['MEX', 'Mexico City', 'Benito Juarez', 'Mexico'],
    ['MAD', 'Madrid', 'Barajas', 'Spain'],
    ['BCN', 'Barcelona', 'El Prat', 'Spain'],
    ['LIS', 'Lisbon', 'Humberto Delgado', 'Portugal'],
    ['CDG', 'Paris', 'Charles de Gaulle', 'France'],
    ['LHR', 'London', 'Heathrow', 'United Kingdom'],
    ['FCO', 'Rome', 'Fiumicino', 'Italy'],
    ['AMS', 'Amsterdam', 'Schiphol', 'Netherlands'],
    ['CPH', 'Copenhagen', 'Kastrup', 'Denmark'],
    ['TLV', 'Tel Aviv', 'Ben Gurion', 'Israel']
  ];

  const label = (p) => p[1] + ' (' + p[0] + ')';
  const code = (t) => {
    t = (t || '').trim();
    const br = t.match(/\(([A-Za-z]{3})\)\s*$/); if (br) return br[1].toUpperCase();
    if (/^[A-Za-z]{3}$/.test(t)) return t.toUpperCase();
    const q = t.toLowerCase();
    const hit = PORTS.find(p => p[1].toLowerCase() === q) || PORTS.find(p => p[1].toLowerCase().indexOf(q) === 0);
    return hit ? hit[0] : '';
  };

  // ---- airport picker -------------------------------------------------------------------------
  function attachPicker(input, panel) {
    let items = [], sel = -1;

    const search = (q) => {
      q = (q || '').trim().toLowerCase();
      if (!q) return PORTS.slice(0, 8);
      const starts = [], has = [];
      PORTS.forEach(p => {
        const city = p[1].toLowerCase(), name = p[2].toLowerCase(), cd = p[0].toLowerCase();
        if (cd === q || city.indexOf(q) === 0) starts.push(p);
        else if (city.indexOf(q) > 0 || name.indexOf(q) >= 0 || cd.indexOf(q) === 0) has.push(p);
      });
      return starts.concat(has).slice(0, 8);
    };

    const draw = () => {
      if (!items.length) { panel.innerHTML = '<div class="ymcAcNone">No airport matches that.</div>'; return; }
      panel.innerHTML = items.map((p, i) =>
        '<div class="ymcAcItem' + (i === sel ? ' sel' : '') + '" data-i="' + i + '">' +
          '<div><div class="ymcAcCity">' + esc(p[1]) + ' · <span style="font-weight:500;color:#6b7a90">' + esc(p[3]) + '</span></div>' +
          '<div class="ymcAcName">' + esc(p[2]) + '</div></div>' +
          '<span class="ymcAcCode">' + esc(p[0]) + '</span>' +
        '</div>').join('');
      [...panel.querySelectorAll('.ymcAcItem')].forEach(el => {
        el.addEventListener('mousedown', (ev) => { ev.preventDefault(); pick(+el.getAttribute('data-i')); });
      });
    };

    const open = () => { items = search(input.value); sel = -1; draw(); panel.classList.add('open'); };
    const close = () => { panel.classList.remove('open'); sel = -1; };
    const pick = (i) => { const p = items[i]; if (!p) return; input.value = label(p); close(); };

    input.addEventListener('focus', open);
    input.addEventListener('input', open);
    input.addEventListener('blur', () => setTimeout(close, 120));
    input.addEventListener('keydown', (e) => {
      if (!panel.classList.contains('open')) { if (e.key === 'ArrowDown') open(); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = Math.min(sel + 1, items.length - 1); draw(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sel = Math.max(sel - 1, 0); draw(); }
      else if (e.key === 'Enter') { if (sel >= 0) { e.preventDefault(); pick(sel); } else { close(); } }
      else if (e.key === 'Escape') { close(); }
    });
  }
  attachPicker($c('ymcFrom'), $c('ymcFromAc'));
  attachPicker($c('ymcTo'), $c('ymcToAc'));

  $c('ymcSwap').addEventListener('click', () => {
    const a = $c('ymcFrom').value; $c('ymcFrom').value = $c('ymcTo').value; $c('ymcTo').value = a;
  });

  $c('ymcMoreBtn').addEventListener('click', () => {
    const m = $c('ymcMore'); const open = m.classList.toggle('open');
    $c('ymcMoreBtn').textContent = open ? 'Fewer options' : 'More options';
  });

  // ---- calendar --------------------------------------------------------------------------------
  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const DOW = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const fmtDate = (v) => {
    if (!v) return '';
    const d = new Date(v + 'T00:00:00');
    return DOW[(d.getDay() + 6) % 7] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()].slice(0, 3) + ' ' + d.getFullYear();
  };

  // ---- the date picker ------------------------------------------------------------------------
  // Shared by the departure date and by every passenger date. It carries a year dropdown as well as
  // month arrows, because a date of birth is thirty years back and nobody should click through 400
  // months to reach it.
  const calPop = document.createElement('div');
  calPop.className = 'ymcCalPop';
  document.body.appendChild(calPop);
  let calCtx = null;

  function limitOf(btn, attr) {
    const v = btn.getAttribute(attr);
    return v === 'today' ? iso(today) : (v || '');
  }

  function openCal(btn) {
    const cur = btn.dataset.v || '';
    const min = limitOf(btn, 'data-min'), max = limitOf(btn, 'data-max');
    let base;
    if (cur) base = new Date(cur + 'T00:00:00');
    else if (max && max < iso(today)) base = new Date(max + 'T00:00:00');   // a birthday: start at the limit
    else base = new Date(today);
    calCtx = { btn: btn, min: min, max: max, m: base.getMonth(), y: base.getFullYear() };
    drawCal();
    const r = btn.getBoundingClientRect();
    calPop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - 296)) + 'px';
    const below = window.innerHeight - r.bottom;
    calPop.style.top = (below > 330 ? r.bottom + 6 : Math.max(8, r.top - 336)) + 'px';
    calPop.classList.add('open');
  }
  function closeCal() { calPop.classList.remove('open'); calCtx = null; }

  function drawCal() {
    const c = calCtx; if (!c) return;
    const minY = c.min ? +c.min.slice(0, 4) : 1920;
    const maxY = c.max ? +c.max.slice(0, 4) : today.getFullYear() + 15;
    const years = [];
    for (let y = maxY; y >= minY; y--) years.push(y);

    const first = new Date(c.y, c.m, 1);
    const startDow = (first.getDay() + 6) % 7;
    const days = new Date(c.y, c.m + 1, 0).getDate();
    const blocked = (v) => (c.min && v < c.min) || (c.max && v > c.max);

    let html =
      '<div class="ymcCalHead">' +
        '<button class="ymcCalNav" data-nav="-1" type="button">‹</button>' +
        '<div class="ymcCalTitle">' +
          '<select class="ymcCalYear" data-year>' + years.map(y => '<option value="' + y + '"' + (y === c.y ? ' selected' : '') + '>' + MONTHS[c.m].slice(0, 3) + ' ' + y + '</option>').join('') + '</select>' +
        '</div>' +
        '<button class="ymcCalNav" data-nav="1" type="button">›</button>' +
      '</div><div class="ymcCalGrid">' +
      DOW.map(d => '<div class="ymcCalDow">' + d + '</div>').join('');
    for (let i = 0; i < startDow; i++) html += '<div></div>';
    for (let d = 1; d <= days; d++) {
      const v = iso(new Date(c.y, c.m, d));
      const cls = 'ymcCalDay' + (v === iso(today) ? ' today' : '') + (v === (c.btn.dataset.v || '') ? ' pick' : '');
      html += '<button type="button" class="' + cls + '" data-d="' + v + '"' + (blocked(v) ? ' disabled' : '') + '>' + d + '</button>';
    }
    calPop.innerHTML = html + '</div>';

    calPop.querySelectorAll('[data-nav]').forEach(b => b.addEventListener('click', (e) => {
      e.stopPropagation();
      c.m += +b.getAttribute('data-nav');
      if (c.m < 0) { c.m = 11; c.y--; }
      if (c.m > 11) { c.m = 0; c.y++; }
      drawCal();
    }));
    const ysel = calPop.querySelector('[data-year]');
    if (ysel) ysel.addEventListener('change', (e) => { e.stopPropagation(); c.y = +ysel.value; drawCal(); });
    calPop.querySelectorAll('[data-d]').forEach(b => b.addEventListener('click', (e) => {
      e.stopPropagation();
      const v = b.getAttribute('data-d');
      c.btn.dataset.v = v;
      c.btn.textContent = fmtDate(v);
      c.btn.classList.add('has');
      c.btn.classList.remove('ymcBad');
      if (c.btn.id === 'ymcDateBtn') selDate = v;
      closeCal();
    }));
  }

  let selDate = '';
  document.addEventListener('click', (e) => {
    const btn = e.target.closest ? e.target.closest('[data-cal]') : null;
    if (btn) { e.stopPropagation(); if (calCtx && calCtx.btn === btn) closeCal(); else openCal(btn); return; }
    if (calPop.classList.contains('open') && !calPop.contains(e.target)) closeCal();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCal(); });
  window.addEventListener('resize', closeCal);
  // true = catch scrolling inside any container, not just the window
  window.addEventListener('scroll', closeCal, true);

  // ---- phone country codes ----------------------------------------------------------------------
  // Flags rather than bare numbers: people recognise their country long before they recall its
  // dialling code.
  const CODES = [
    ['1', '🇨🇦 +1'], ['1', '🇺🇸 +1'], ['44', '🇬🇧 +44'],
    ['972', '🇮🇱 +972'], ['54', '🇦🇷 +54'], ['55', '🇧🇷 +55'],
    ['52', '🇲🇽 +52'], ['33', '🇫🇷 +33'], ['34', '🇪🇸 +34'],
    ['39', '🇮🇹 +39'], ['31', '🇳🇱 +31'], ['351', '🇵🇹 +351'],
    ['56', '🇨🇱 +56'], ['57', '🇨🇴 +57'], ['51', '🇵🇪 +51'],
    ['45', '🇩🇰 +45']
  ];
  $c('ymcCcode').innerHTML = CODES.map(([v, t]) => '<option value="' + v + '">' + t + '</option>').join('');

  // ---- search -----------------------------------------------------------------------------------
  const stopCount = (f) => (typeof f.stops === 'number' ? f.stops : (f.stopover ? 1 : 0));
  const layoverHrs = (f) => { if (!f.stopover) return 0; const d = f.stopover.duration || ''; const hh = +((d.match(/(\d+)\s*h/) || [])[1] || 0); const mm = +((d.match(/(\d+)\s*min/) || [])[1] || 0); return hh + mm / 60; };

  let found = [], searchedAdults = 0, lastRows = [];

  $c('ymcGo').addEventListener('click', async () => {
    const origin = code($c('ymcFrom').value), destination = code($c('ymcTo').value);
    const date = selDate, adults = parseInt($c('ymcPax').value, 10) || 1;
    if (!origin || !destination) { say('Please choose a city or airport for both From and To.'); return; }
    if (origin === destination) { say('Those are the same airport — pick a different destination.'); return; }
    if (!date) { say('Please choose a departure date.'); return; }

    $c('ymcGo').disabled = true;
    $c('ymcResults').innerHTML = '';
    $c('ymcPaxStep').style.display = 'none';
    $c('ymcDone').style.display = 'none';      // a finished booking must not sit over a new search
    $c('ymcResults').style.display = 'grid';
    say('Searching live award availability — this can take up to a minute.');

    // SAME RULE AS THE PROCESSOR: only fetch each flight's boarding tax when the route has no
    // preset price. Pricing costs one call per flight and the core routes are all priced.
    const priceIt = !isRoutePriced(origin, destination);
    const res = await searchViaBridge({ origin, destination, date, adults, price: priceIt });
    searchedAdults = adults;
    $c('ymcGo').disabled = false;
    if (!res || !res.ok) { say('Search failed: ' + ((res && res.error) || 'no response from the booking bridge')); return; }

    const maxStops = parseInt($c('ymcStops').value, 10) || 0;
    const maxLay = parseFloat($c('ymcLayover').value) || 0;
    found = (res.flights || []).filter(f => {
      if (!(f.milesClub || f.miles) || f.available === false) return false;
      if (stopCount(f) > maxStops) return false;
      if (maxLay && stopCount(f) > 0 && layoverHrs(f) > maxLay) return false;
      return true;
    });

    const rows = found.map((f, i) => {
      const p = getPrice(f.airline, f.classType, f.origin, f.destination, f);
      const n = parseFloat(String(p).replace(/[^0-9.]/g, ''));
      return { f, i, p, n: isNaN(n) ? null : n };
    }).filter(r => r.n).sort((a, b) => a.n - b.n);
    lastRows = rows;

    if (!rows.length) {
      say('');
      $c('ymcResults').innerHTML = '<div class="ymcEmpty">No award seats on that date. Try a nearby day, or allow a stop under More options.</div>';
      return;
    }
    filt.dest.clear(); filt.orig.clear(); filt.cabin.clear(); filt.from = ''; filt.to = '';
    drawResults();
  });

  // ---- results ------------------------------------------------------------------------------
  // One card per FLIGHT, not per fare. Economy and Business on the same aircraft were appearing as
  // two unrelated rows at the same time of day, which reads as a duplicate rather than a choice.
  let curSort = 'price';
  const filt = { dest: new Set(), orig: new Set(), cabin: new Set(), from: '', to: '' };
  const mins = (t) => { const m = String(t || '').match(/(\d{1,2})h(\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : 0; };
  const flightKey = (f) => [f.origin, f.destination, f.departure, f.arrival, stopCount(f), f.airline].join('|');
  const portOf = (c) => PORTS.find(p => p[0] === c);
  const portLabel = (c) => { const p = portOf(c); return p ? p[1] + ' ' + p[2] + ' (' + c + ')' : c; };
  const portShort = (c) => { const p = portOf(c); return p ? p[2] : c; };
  const cabinOf = (f) => (/business|ejecutiv/i.test(f.classType || '') ? 'Business' : 'Economy');
  // Smiles' search does not return a duration, so derive it. A negative gap means it lands the
  // next day, which is what the "+1" on every airline site means.
  function legTime(f) {
    const d = mins(f.departure), a = mins(f.arrival);
    const total = (a - d + 1440) % 1440;
    return { text: Math.floor(total / 60) + 'h ' + String(total % 60).padStart(2, '0') + 'm', next: a < d };
  }
  // What the fare includes, shown as bags rather than ticks: one for the carry-on, two more when
  // business brings checked bags.
  const bagIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="14" rx="2"/>' +
    '<path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M3 12h18"/></svg>';
  const bagsFor = (cab) => cab === 'Business'
    ? [[1, 'Carry-on bag'], [2, '2 checked bags']]
    : [[1, 'Carry-on bag']];
  const HOURS = Array.from({ length: 24 }, (_, h) => [h, (h % 12 || 12) + (h < 12 ? ' AM' : ' PM')]);

  function groupFlights() {
    // One card per FLIGHT, not per fare: Economy and Business on the same aircraft are a choice,
    // not two results.
    const groups = new Map();
    lastRows.forEach(r => {
      const k = flightKey(r.f);
      if (!groups.has(k)) groups.set(k, { f: r.f, fares: [] });
      groups.get(k).fares.push(r);
    });
    const list = [...groups.values()];
    list.forEach(g => g.fares.sort((a, b) => a.n - b.n));
    return list;
  }

  // How far a departure sits outside the wanted window, in minutes. Zero means inside it.
  function outsideBy(f) {
    const m = mins(f.departure);
    const lo = filt.from === '' ? null : +filt.from * 60;
    const hi = filt.to === '' ? null : +filt.to * 60 + 59;
    if (lo !== null && m < lo) return lo - m;
    if (hi !== null && m > hi) return m - hi;
    return 0;
  }

  function drawResults() {
    const all = groupFlights();
    const destPorts = [...new Set(all.map(g => g.f.destination))];
    const origPorts = [...new Set(all.map(g => g.f.origin))];
    const cabins = [...new Set(all.map(g => g.fares.map(r => cabinOf(r.f))).reduce((a, b) => a.concat(b), []))];

    let shown = all.filter(g => {
      if (filt.dest.size && !filt.dest.has(g.f.destination)) return false;
      if (filt.orig.size && !filt.orig.has(g.f.origin)) return false;
      return true;
    }).map(g => {
      const fares = filt.cabin.size ? g.fares.filter(r => filt.cabin.has(cabinOf(r.f))) : g.fares;
      return fares.length ? { f: g.f, fares: fares } : null;
    }).filter(Boolean);

    // A time window narrows the list — but if nothing departs inside it, showing an empty page is
    // unhelpful. Fall back to the whole list ordered by how close each one comes.
    let nearestNote = '';
    const timeSet = filt.from !== '' || filt.to !== '';
    if (timeSet) {
      const inside = shown.filter(g => outsideBy(g.f) === 0);
      if (inside.length) shown = inside;
      else {
        shown = shown.slice().sort((a, b) => outsideBy(a.f) - outsideBy(b.f));
        nearestNote = 'Nothing departs in that window — the closest departures are shown first.';
      }
    }

    // When we are showing the closest departures instead, that ordering IS the answer — leave it.
    if (!nearestNote) {
      shown.sort((a, b) =>
        curSort === 'early' ? mins(a.f.departure) - mins(b.f.departure)
        : curSort === 'late' ? mins(b.f.departure) - mins(a.f.departure)
        : a.fares[0].n - b.fares[0].n);
    }

    const box = (group, code, text, n) =>
      '<label class="ymcCheck"><input type="checkbox" data-f="' + group + '" value="' + esc(code) + '"' +
      (filt[group].has(code) ? ' checked' : '') + '><span>' + esc(text) + '</span><b>' + n + '</b></label>';
    const radio = (val, text) =>
      '<label class="ymcRadioRow"><input type="radio" name="ymcSortR" value="' + val + '"' +
      (curSort === val ? ' checked' : '') + '><span>' + text + '</span></label>';
    const hourSel = (which) =>
      '<select class="ymcTimeSel" data-t="' + which + '">' +
        '<option value="">' + (which === 'from' ? 'Any' : 'Any') + '</option>' +
        HOURS.map(([h, t]) => '<option value="' + h + '"' + (String(filt[which]) === String(h) ? ' selected' : '') + '>' + t + '</option>').join('') +
      '</select>';

    const anyFilter = !!(filt.dest.size || filt.orig.size || filt.cabin.size || timeSet);
    let side =
      '<div class="ymcSideTop"><span class="ymcSideTitle">Filters</span>' +
        '<button class="ymcReset" type="button"' + (anyFilter ? '' : ' disabled') + '>Reset all</button></div>' +
      '<div class="ymcSideH">Sort by</div>' +
      radio('price', 'Cheapest first') + radio('early', 'Earliest departure') + radio('late', 'Latest departure') +
      '<div class="ymcSideH">Departs between</div>' +
      '<div class="ymcTimeRow">' + hourSel('from') + '<span class="ymcTimeTo">to</span>' + hourSel('to') + '</div>';

    if (destPorts.length > 1) {
      side += '<div class="ymcSideH">Arrive at</div>' +
        destPorts.map(c => box('dest', c, portShort(c), all.filter(g => g.f.destination === c).length)).join('');
    }
    if (origPorts.length > 1) {
      side += '<div class="ymcSideH">Depart from</div>' +
        origPorts.map(c => box('orig', c, portShort(c), all.filter(g => g.f.origin === c).length)).join('');
    }
    if (cabins.length > 1) {
      side += '<div class="ymcSideH">Cabin</div>' +
        cabins.map(c => box('cabin', c, c, all.filter(g => g.fares.some(r => cabinOf(r.f) === c)).length)).join('');
    }

    const bar = '<div class="ymcBar"><span class="ymcCount">' + shown.length + ' flight' +
      (shown.length === 1 ? '' : 's') + '</span></div>';

    const cards = shown.length ? shown.map(g => {
      const f = g.f, st = stopCount(f);
      const stopTxt = st ? st + ' stop' + (st > 1 ? 's' : '') + (f.stopover ? ' via ' + esc(f.stopover.airport) : '') : 'Direct';
      const lay = (st && f.stopover && f.stopover.duration) ? '<span class="ymcDot">·</span>' + esc(f.stopover.duration) + ' layover' : '';
      return '<div class="ymcCard ymcFlight">' +
        '<div>' +
          '<div class="ymcTimes">' + esc(ampm(f.departure)) + '<span class="ymcArrow">→</span>' + esc(ampm(f.arrival)) +
            (legTime(f).next ? '<sup style="color:#4a5a72;font-size:11px;font-weight:700"> +1</sup>' : '') + '</div>' +
          '<div class="ymcAirports">' + esc(portLabel(f.origin)) + ' → ' + esc(portLabel(f.destination)) + '</div>' +
          '<div class="ymcMeta">' + esc(f.airline || 'Airline') + '<span class="ymcDot">·</span>' + stopTxt +
            '<span class="ymcDot">·</span>' + legTime(f).text + lay + '</div>' +
        '</div>' +
        '<div class="ymcFares">' + g.fares.map(r => {
          const cab = cabinOf(r.f);
          return '<button class="ymcFare" data-i="' + r.i + '">' +
            '<span class="ymcFareCabin ' + (cab === 'Business' ? 'biz' : 'eco') + '">' + cab + '</span>' +
            '<span class="ymcFarePrice">' + esc(r.p) + '</span>' +
            '<span class="ymcFareGo">Select</span>' +
          '</button>';
        }).join('') +
        '</div>' +
      '</div>';
    }).join('') : '<div class="ymcEmpty">Nothing matches those filters. Clear one to see more.</div>';

    say('');
    $c('ymcResults').innerHTML =
      '<div class="ymcSplit"><aside class="ymcSide">' + side + '</aside>' +
      '<div class="ymcList">' + bar + (nearestNote ? '<div class="ymcNote">' + nearestNote + '</div>' : '') + cards + '</div></div>';

    view.querySelectorAll('[data-f]').forEach(cb => cb.addEventListener('change', () => {
      const g = cb.getAttribute('data-f');
      if (cb.checked) filt[g].add(cb.value); else filt[g].delete(cb.value);
      drawResults();
    }));
    view.querySelectorAll('input[name="ymcSortR"]').forEach(r => r.addEventListener('change', () => {
      curSort = r.value; drawResults();
    }));
    view.querySelectorAll('[data-t]').forEach(sel => sel.addEventListener('change', () => {
      filt[sel.getAttribute('data-t')] = sel.value; drawResults();
    }));
    const reset = view.querySelector('.ymcReset');
    if (reset) reset.addEventListener('click', () => {
      filt.dest.clear(); filt.orig.clear(); filt.cabin.clear(); filt.from = ''; filt.to = '';
      drawResults();
    });
    view.querySelectorAll('.ymcFare').forEach(b => b.addEventListener('click', () => {
      // If this throws, the button looks simply dead and there is nothing to go on. Say so
      // instead: a visible error is worth far more than a silent one when it only happens on the
      // second booking and cannot be reproduced on demand.
      try {
        const f = found[+b.getAttribute('data-i')];
        if (!f) { say('That flight is no longer in the results — please search again.'); return; }
        openPaxStep(f, lastRows.find(r => r.f === f));
      } catch (err) {
        const msg = 'Select failed: ' + (err && err.message ? err.message : String(err));
        say(msg);
        // The status line sits at the top of the page and you are scrolled down among the
        // results when you press Select, so put it somewhere it cannot be missed.
        if (window.__ymShowError) window.__ymShowError(msg, err && err.stack ? String(err.stack).split('\n')[1] : '');
      }
    }));
  }

  // ---- who is flying ----------------------------------------------------------------------------
  // The booking carries its own travellers from here on, so it can never be completed with another
  // customer's details.
  let chosen = null, chosenRow = null, tripRef = '';
  let confirmedWarnings = false;   // a passport warning is shown once; pressing Confirm again accepts it

  function openPaxStep(f, row) {
    chosen = f;
    chosenRow = row || null;
    const n = searchedAdults || 1;
    const st = stopCount(f);
    const cab = cabinOf(f);
    const t = legTime(f);
    const each = row && row.n ? row.n : 0;
    const money = (x) => '$' + x.toLocaleString('en-US');

    $c('ymcSummary').innerHTML =
      '<div class="ymcSum">' +
        '<div class="ymcSumH">' + esc((portOf(f.origin) || [, f.origin])[1]) + ' to ' + esc((portOf(f.destination) || [, f.destination])[1]) + '</div>' +
        '<div class="ymcSumSub">One-way · ' + cab + ' · ' + n + ' traveller' + (n > 1 ? 's' : '') + '</div>' +
        '<div class="ymcSumLeg">' +
          '<div class="ymcSumRoute">' + esc(f.origin) + ' <span class="ymcArrow">→</span> ' + esc(f.destination) +
            '<span style="float:right;font-weight:700;font-size:12.5px;color:#22314d">' + esc(ampm(f.departure)) + '</span></div>' +
          '<div class="ymcSumWhen">' + esc($c('ymcDateBtn').textContent) + '</div>' +
          '<div class="ymcSumMeta">' + esc(f.airline || '') + '<span class="ymcDot">·</span>' +
            (st ? st + ' stop' + (st > 1 ? 's' : '') : 'Nonstop') + '<span class="ymcDot">·</span>' + t.text +
            (t.next ? ' · arrives next day' : '') + '</div>' +
          '<div class="ymcBags">' + bagsFor(cab).map(([n, t]) =>
            '<div class="ymcBag"><span class="ymcBagIcons">' + bagIcon.repeat(n) + '</span>' + t + ' included</div>').join('') + '</div>' +
        '</div>' +
        (each ? '<div class="ymcSumRow"><span>' + n + ' ticket' + (n > 1 ? 's' : '') + '</span><span>' + money(each * n) + '</span></div>' +
                '<div class="ymcSumRow"><span>Taxes and fees</span><span>Included</span></div>' +
                '<div class="ymcSumTotal"><span>Total</span><span>' + money(each * n) + '</span></div>' : '') +
        '<button id="ymcBack" class="ymcBackBtn" type="button" style="width:100%;margin-top:12px">← Change flight</button>' +
        '<div class="ymcSumNote">Nothing is charged until the flight is ticketed.</div>' +
      '</div>';
    $c('ymcBack').addEventListener('click', backToResults);

    $c('ymcPaxForms').innerHTML = Array.from({ length: n }, (_, i) => paxBlockHtml(i, n)).join('');
    // Attach the nationality pickers now the blocks exist.
    for (let i = 0; i < n; i++) {
      const inp = $c('ymcpx_nationality' + i);
      const pan = $c('ymcPaxForms').querySelector('[data-ac="' + i + '"]');
      if (inp && pan) attachOptions(inp, pan, NATIONALITIES);
    }
    $c('ymcResults').style.display = 'none';
    $c('ymcDone').style.display = 'none';
    $c('ymcPaxStep').style.display = 'block';
    // A previous booking left the button mid-send. Reset it, or the next one looks already sent.
    const cbtn = $c('ymcConfirm');
    if (cbtn) { cbtn.disabled = false; cbtn.textContent = 'Confirm request'; }
    const cerr = $c('ymcPaxErr');
    if (cerr) { cerr.style.display = 'none'; cerr.textContent = ''; }
    confirmedWarnings = false;     // a new flight gets its own warnings, not the last one's
    say('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    tripRef = 'YM-' + Math.random().toString(36).slice(2, 6).toUpperCase() + Math.random().toString(36).slice(2, 4).toUpperCase();
    setupPayment(each ? Math.round(each * n * 100) : 0, tripRef, f, n);
  }

  function paxBlockHtml(i, n) {
    const L = (s, f) => '<label class="ymcLbl" for="ymcpx_' + f + i + '">' + s + '</label>';
    const I = (f, extra) => '<input id="ymcpx_' + f + i + '" class="ymcInput" data-px="' + f + '" data-i="' + i + '" ' + (extra || '') + '>';
    return '<div class="ymcPaxHead">' + (n > 1 ? 'Traveller ' + (i + 1) : 'Traveller') + '</div>' +
      '<div class="ymcGrid2">' +
        '<div>' + L('First name', 'first') + I('first', 'autocomplete="off"') + '</div>' +
        '<div>' + L('Last name', 'last') + I('last', 'autocomplete="off"') + '</div>' +
        '<div class="ymcWide">' + L('Middle name', 'middle') + '<span class="ymcOpt"> optional, as shown in the passport</span>' + I('middle', 'autocomplete="off"') + '</div>' +
        '<div>' + L('Date of birth', 'dob') +
          '<button type="button" id="ymcpx_dob' + i + '" class="ymcInput ymcDateBtn" data-px="dob" data-i="' + i + '" data-cal data-max="today">Choose a date</button></div>' +
        '<div class="ymcField">' + L('Nationality', 'nationality') +
          '<input id="ymcpx_nationality' + i + '" class="ymcInput" data-px="nationality" data-i="' + i +
          '" placeholder="Start typing\u2026" autocomplete="off" spellcheck="false">' +
          '<div class="ymcAc" data-ac="' + i + '"></div>' + '</div>' +
        '<div>' + L('Passport number', 'passport') + I('passport', 'autocomplete="off"') + '</div>' +
        '<div>' + L('Passport expiry', 'passportExp') +
          '<button type="button" id="ymcpx_passportExp' + i + '" class="ymcInput ymcDateBtn" data-px="passportExp" data-i="' + i + '" data-cal data-min="today">Choose a date</button></div>' +
        '<div class="ymcWide"><span class="ymcLbl">Gender</span>' +
          '<div class="ymcSeg">' +
            '<label><input type="radio" name="ymcG' + i + '" value="M" checked> Male</label>' +
            '<label><input type="radio" name="ymcG' + i + '" value="F"> Female</label>' +
          '</div>' +
        '</div>' +
        '<div>' + L('Frequent flyer number', 'ff') + '<span class="ymcOpt"> optional</span>' + I('ff', 'autocomplete="off"') + '</div>' +
        '<div>' + L('Known traveller / redress no.', 'ktn') + '<span class="ymcOpt"> optional</span>' + I('ktn', 'autocomplete="off"') + '</div>' +
      '</div>';
  }

  // Smiles' own nationality list is in Spanish, so the driver maps these across. Commonest first.
  const NATIONALITIES = ['Canadian','American','British','Israeli','Brazilian','Argentine','Mexican',
    'French','Spanish','Italian','Portuguese','German','Dutch','Swiss','Chilean','Colombian',
    'Peruvian','Australian','Irish','Belgian','Danish','Swedish','Norwegian','Polish','Russian',
    'Chinese','Indian','Japanese','South African','Other'];

  // A plain list picker, sharing the airport picker's behaviour: filters as you type, arrow keys,
  // and — unlike a native dropdown — it does not vanish the instant the page scrolls.
  function attachOptions(input, panel, list) {
    let items = [], sel = -1;
    const search = (q) => {
      q = (q || '').trim().toLowerCase();
      if (!q) return list.slice(0, 10);
      return list.filter(n => n.toLowerCase().indexOf(q) === 0)
        .concat(list.filter(n => n.toLowerCase().indexOf(q) > 0)).slice(0, 10);
    };
    const draw = () => {
      panel.innerHTML = items.length
        ? items.map((n, i) => '<div class="ymcAcItem' + (i === sel ? ' sel' : '') + '" data-i="' + i + '"><div class="ymcAcCity">' + esc(n) + '</div></div>').join('')
        : '<div class="ymcAcNone">No match.</div>';
      [...panel.querySelectorAll('.ymcAcItem')].forEach(el =>
        el.addEventListener('mousedown', (ev) => { ev.preventDefault(); pick(+el.getAttribute('data-i')); }));
    };
    const open = () => { items = search(input.value); sel = -1; draw(); panel.classList.add('open'); };
    const close = () => panel.classList.remove('open');
    const pick = (i) => { if (items[i]) { input.value = items[i]; input.classList.remove('ymcBad'); } close(); };
    input.addEventListener('focus', open);
    input.addEventListener('input', open);
    input.addEventListener('blur', () => setTimeout(close, 120));
    input.addEventListener('keydown', (e) => {
      if (!panel.classList.contains('open')) { if (e.key === 'ArrowDown') open(); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = Math.min(sel + 1, items.length - 1); draw(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sel = Math.max(sel - 1, 0); draw(); }
      else if (e.key === 'Enter') { if (sel >= 0) { e.preventDefault(); pick(sel); } else close(); }
      else if (e.key === 'Escape') close();
    });
  }

  // Smiles wants DD/MM/YYYY; a date input gives YYYY-MM-DD.
  const toSmilesDate = (v) => { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || ''); return m ? m[3] + '/' + m[2] + '/' + m[1] : (v || ''); };

  function backToResults() {
    $c('ymcPaxStep').style.display = 'none';
    $c('ymcDone').style.display = 'none';
    $c('ymcResults').style.display = 'block';
    chosen = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ---- payment -------------------------------------------------------------------------------
  // The card is AUTHORISED here and captured only when the flight is ticketed, so the promise on
  // the confirmation screen — nothing charged until it is booked — is true in the code too.
  // Until the Stripe keys are set in Cloudflare the section stays hidden and the site behaves
  // exactly as it did before, rather than blocking requests behind a card field that cannot work.
  let payCfg = null, stripe = null, elements = null, payIntentId = '';

  function loadStripeJs() {
    if (window.Stripe) return Promise.resolve();
    return new Promise((res, rej) => {
      const sc = document.createElement('script');
      sc.src = 'https://js.stripe.com/v3/';
      sc.onload = res; sc.onerror = () => rej(new Error('Stripe could not load'));
      document.head.appendChild(sc);
    });
  }

  async function setupPayment(totalCents, ref, f, n) {
    payIntentId = '';
    $c('ymcPaySection').style.display = 'none';
    $c('ymcStepNum').textContent = '3';
    if (!totalCents) return;
    try {
      if (!payCfg) payCfg = await (await fetch('/api/stripe')).json();
      if (!payCfg || !payCfg.configured) return;                 // keys not set yet — carry on without

      await loadStripeJs();
      const r = await fetch('/api/stripe', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'authorise', amount: totalCents, currency: 'usd', ref: ref,
          email: ($c('ymcEmail').value || '').trim(),
          route: f.origin + '-' + f.destination, departs: selDate, travellers: String(n),
          description: 'YM Travels ' + f.origin + '-' + f.destination + ' ' + selDate
        })
      });
      const data = await r.json();
      if (!data.ok) throw new Error(data.error || 'Could not start the payment');

      payIntentId = data.id;
      stripe = window.Stripe(payCfg.publishableKey);
      elements = stripe.elements({
        clientSecret: data.clientSecret,
        appearance: { theme: 'stripe', variables: { colorPrimary: '#2b6cff', borderRadius: '9px', fontFamily: 'Plus Jakarta Sans, sans-serif' } }
      });
      elements.create('payment', { layout: 'tabs' }).mount('#ymcPayEl');
      $c('ymcTestBanner').style.display = payCfg.mode === 'test' ? 'block' : 'none';
      $c('ymcPaySection').style.display = '';
      $c('ymcStepNum').textContent = '4';
      $c('ymcFootNote').textContent = 'Your card is held now and charged only once the flight is ticketed. If the seat has gone, the hold is released and you pay nothing.';
    } catch (e) {
      // Never strand a customer because payment setup failed — let the request through and sort
      // the card out by hand.
      payIntentId = '';
      $c('ymcPaySection').style.display = 'none';
      $c('ymcStepNum').textContent = '3';
    }
  }

  $c('ymcConfirm').addEventListener('click', () => {
    if (!chosen) return;
    const n = searchedAdults || 1;
    const fields = ['first', 'last', 'dob', 'nationality', 'passport', 'passportExp'];
    const missing = [];
    view.querySelectorAll('.ymcBad').forEach(el => el.classList.remove('ymcBad'));

    const pax = [];
    for (let i = 0; i < n; i++) {
      const p = {};
      fields.forEach(k => {
        const el = view.querySelector('[data-px="' + k + '"][data-i="' + i + '"]');
        const isDate = (k === 'dob' || k === 'passportExp');
        const v = (isDate ? (el && el.dataset.v) || '' : (el && el.value) || '').trim();
        if (!v) missing.push(el);
        p[k] = isDate ? toSmilesDate(v) : v;
      });
      const g = view.querySelector('input[name="ymcG' + i + '"]:checked');
      p.gender = g ? g.value : 'M';
      // Optional, and recorded rather than typed into Smiles — its passenger form has no field for
      // any of them. They travel with the order so they are on hand when they matter.
      ['middle', 'ff', 'ktn'].forEach(k => {
        const el = view.querySelector('[data-px="' + k + '"][data-i="' + i + '"]');
        p[k] = ((el && el.value) || '').trim();
      });
      pax.push(p);
    }
    const contact = {
      email: ($c('ymcEmail').value || '').trim(),
      ccode: ($c('ymcCcode').value || '').trim(),
      area: ($c('ymcArea').value || '').trim(),
      phone: ($c('ymcPhone').value || '').replace(/\D/g, '')
    };
    if (!contact.email) missing.push($c('ymcEmail'));
    if (!contact.area) missing.push($c('ymcArea'));
    if (!contact.phone) missing.push($c('ymcPhone'));

    if (missing.length) {
      missing.forEach(el => el && el.classList.add('ymcBad'));
      const err = $c('ymcPaxErr');
      err.textContent = 'Please fill the highlighted ' + (missing.length === 1 ? 'field' : 'fields') + ' — Smiles needs every one of them.';
      err.style.display = 'block';
      if (missing[0] && missing[0].scrollIntoView) missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // ---- the same person twice -----------------------------------------------------------
    // Always a mistake, and one Smiles will happily accept: two identical passengers on one
    // booking means one of the two people who are actually travelling has no seat.
    const seen = {};
    let dupAt = -1;
    pax.forEach((p, i) => {
      const k = (p.first + '|' + p.last + '|' + p.dob).toLowerCase();
      if (seen[k] !== undefined && dupAt < 0) dupAt = i; else seen[k] = i;
    });
    if (dupAt >= 0) {
      const err = $c('ymcPaxErr');
      err.textContent = 'Traveller ' + (dupAt + 1) + ' has the same name and date of birth as an earlier traveller. Each person on the booking must be different.';
      err.style.display = 'block';
      const el = view.querySelector('[data-px="first"][data-i="' + dupAt + '"]');
      if (el) { el.classList.add('ymcBad'); if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }

    // ---- age at the DEPARTURE date, not today ----------------------------------------------
    // A child who turns 12 the week before the flight travels as an adult. Dating the check to
    // the flight is the only version that is right.
    pax.forEach(p => {
      p.ageGroup = 'adult';
      const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(p.dob || '');   // dd/mm/yyyy, Smiles' shape
      if (!m || !selDate) return;
      const born = new Date(+m[3], +m[2] - 1, +m[1]);
      const dep = new Date(selDate + 'T00:00:00');
      let age = dep.getFullYear() - born.getFullYear();
      const md = dep.getMonth() - born.getMonth();
      if (md < 0 || (md === 0 && dep.getDate() < born.getDate())) age--;
      p.age = age;
      p.ageGroup = age < 2 ? 'infant' : age < 12 ? 'child' : 'adult';
    });

    // ---- passport validity ------------------------------------------------------------------
    // A warning, not a block: six months past travel is the common rule but not a universal one,
    // and refusing a booking outright over a rule that may not apply is worse than flagging it.
    const soon = [];
    pax.forEach((p, i) => {
      const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(p.passportExp || '');
      if (!m || !selDate) return;
      const exp = new Date(+m[3], +m[2] - 1, +m[1]);
      const dep = new Date(selDate + 'T00:00:00');
      if (exp <= dep) { p.passportFlag = 'expired'; soon.push('Traveller ' + (i + 1) + '’s passport expires before the flight'); return; }
      const sixMonths = new Date(dep.getFullYear(), dep.getMonth() + 6, dep.getDate());
      if (exp < sixMonths) { p.passportFlag = 'under6m'; soon.push('Traveller ' + (i + 1) + '’s passport expires within 6 months of travel'); }
    });
    if (soon.length && !confirmedWarnings) {
      const err = $c('ymcPaxErr');
      err.innerHTML = esc(soon.join('. ')) + '. Many countries require six months’ validity beyond your travel date. ' +
        '<b>Check the passport, then press Confirm again to continue.</b>';
      err.style.display = 'block';
      confirmedWarnings = true;
      if (err.scrollIntoView) err.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    $c('ymcPaxErr').style.display = 'none';
    // Contact details sit on every traveller, because that is the shape the booking driver fills.
    pax.forEach(p => Object.assign(p, contact));

    const f = chosen;
    const btn = $c('ymcConfirm');
    btn.disabled = true; btn.textContent = 'Sending…';
    sendOrder(f, n, pax, contact);
  });

  async function sendOrder(f, n, pax, contact) {
    const btn = $c('ymcConfirm');
    // Authorise the card before the request is queued: a booking nobody can pay for is worse than
    // one that was never taken.
    if (stripe && elements && payIntentId) {
      btn.textContent = 'Confirming your card…';
      $c('ymcPayErr').style.display = 'none';
      const res = await stripe.confirmPayment({ elements: elements, redirect: 'if_required' });
      if (res.error) {
        btn.disabled = false; btn.textContent = 'Confirm request';
        const pe = $c('ymcPayErr');
        pe.textContent = res.error.message || 'That card was declined. Please try another.';
        pe.style.display = 'block';
        $c('ymcPaySection').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      btn.textContent = 'Sending…';
    }
    window.postMessage({ __ymReq: 'queue', order: {
      origin: f.origin, destination: f.destination, date: selDate,
      dep: f.departure, cabin: f.classType, stops: stopCount(f), miles: [f.milesClub, f.miles].filter(Boolean),
      adults: n, pax: pax, contact: contact,
      price: getPrice(f.airline, f.classType, f.origin, f.destination, f),
      airline: f.airline, source: 'customer',
      ref: tripRef, paymentIntent: payIntentId || '',
      // Anything on this booking that a person has to look at before it is flown. A child or an
      // infant is not a booking the driver should finish on its own.
      attention: [
        pax.some(p => p.ageGroup === 'infant') ? 'infant on board' : '',
        pax.some(p => p.ageGroup === 'child') ? 'child under 12' : '',
        pax.some(p => p.passportFlag === 'expired') ? 'passport expires before travel' : '',
        pax.some(p => p.passportFlag === 'under6m') ? 'passport under 6 months' : ''
      ].filter(Boolean)
    } }, '*');
    say('');
  }

  window.addEventListener('message', (e) => {
    if (e.source !== window || !e.data) return;
    if (e.data.__ymBridge === 'ready' && e.data.version) $c('ymcVer').textContent = 'build ' + __BUILD__ + ' · ext v' + e.data.version;
    if (e.data.__ymRes !== 'queue') return;
    const btn = $c('ymcConfirm');
    if (e.data.ok) {
      // Into its own panel — never over the top of the form. See the note in customer.html.
      $c('ymcPaxStep').style.display = 'none';
      const done = $c('ymcDone');
      done.style.display = 'block';
      done.innerHTML =
        '<div class="ymcCard" style="text-align:center;padding:44px 22px">' +
          '<div style="width:52px;height:52px;margin:0 auto 14px;border-radius:50%;background:#e7f7ef;color:#0e9f5c;font-size:26px;line-height:52px">✓</div>' +
          '<h2 class="ymcH2">Request received</h2>' +
          (tripRef ? '<div style="margin:6px 0 0;font:800 15px \'Plus Jakarta Sans\',sans-serif;letter-spacing:.04em;color:#2b6cff">' + esc(tripRef) + '</div>' : '') +
          '<p class="ymcHint" style="margin:8px auto 0;max-width:36em">' +
            'We are confirming the seats now and will email your booking code. ' +
            (payIntentId ? 'Your card is held, not charged — we take payment only once the flight is ticketed.'
                         : 'Nothing has been charged — you only pay once the flight is ticketed.') + '</p>' +
          '<button id="ymcAgain" class="ymcBackBtn" type="button" style="margin:18px auto 0">Book another flight</button>' +
        '</div>';
      $c('ymcAgain').addEventListener('click', () => {
        done.style.display = 'none';
        $c('ymcResults').style.display = 'block';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      say('');
    } else {
      if (btn) { btn.disabled = false; btn.textContent = 'Confirm request'; }
      const err = $c('ymcPaxErr');
      if (err) { err.textContent = 'Could not send that request: ' + (e.data.error || 'unknown') + '. Please try again.'; err.style.display = 'block'; }
    }
  });
}
